import React, { useEffect, useState } from "react";
import "./CricketHomepage.css";
import PlayersSection from "./PlayersSection";
import OurOfferings from "./OurOfferings";
import ForthcomingEvents from "./ForthcomingEvents";
import CricketGallery from "./CricketGallery";
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaCalendarAlt } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const groups = {
  "Group A": ["AJVJ", "SK Salem", "Queens"],
  "Group B": ["Risor", "SK SRMC", "Fearless"],
  "Group C": ["Uttarakhand", "Guru Nanak", "SK Drome"],
  "Group D": ["Signature", "Kairaa", "Believe"],
};

const schedule = [
  { date: "Dec 14, 2025", t1: "AJVJ vs SK Salem", t2: "AJVJ vs Queens", t3: "Queens vs SK Salem" },
  { date: "Dec 15, 2025", t1: "Signature vs Kairaa", t2: "Signature vs Believe", t3: "Kairaa vs Believe" },
  { date: "Dec 16, 2025", t1: "Risor vs SK SRMC", t2: "SK SRMC vs Fearless", t3: "Fearless vs Risor" },
  { date: "Dec 17, 2025", t1: "Uttarakhand vs Guru Nanak", t2: "Guru Nanak vs SK Drome", t3: "SK Drome vs Uttarakhand" },
  { date: "Dec 18, 2025", t1: "QF A1 vs D2", t2: "-", t3: "QF D1 vs A2" },
  { date: "Dec 19, 2025", t1: "QF B1 vs C2", t2: "-", t3: "QF B2 vs C1" },
  { date: "Dec 20, 2025", t1: "SF 1 Winner QF1 vs QF4", t2: "-", t3: "SF 2 Winner QF2 vs QF3" },
  { date: "Dec 21, 2025", t1: "Third Place", t2: "-", t3: "Final" },
];

const teamMembers = [
  { img: "/Images/jb3.png", name: "Jasprit Bumrah", role: "Bowler" },
  { img: "/Images/teamp1.png", name: "Virat Kohli", role: "Batsman" },
  { img: "/Images/teamp2.png", name: "Rohit Sharma", role: "Batsman" },
  { img: "/Images/team3.png", name: "MS Dhoni", role: "Wicket Keeper" },
  { img: "/Images/teamp5.png", name: "Ravindra Jadeja", role: "All-Rounder" },
];
const textSlides = [
  {
    title: "EVENT HIGHLIGHTS",
    points: [
      "12 Elite Women's Teams",
      "20 High-Intensity Matches",
      "Live Scoring & Analytics",
      "National-Level Tournament",
    ],
  },
  {
    title: "PRIZE MONEY",
    points: [
      " Champions: ₹3,00,000",
      " Runner-Up: ₹2,00,000",
      " Third Place: ₹1,00,000",
      "Awards for Best Player & Emerging Talent",
    ],
  },
  {
    title: "WHY THIS MATTERS",
    points: [
      "Platform for Rising Women Cricketers",
      "Professional Tournament Experience",
      "Recognition at National Level",
      "Boosting India's Women's Cricket Ecosystem",
    ],
  },
];
const matchFixtures = [
  // ------------------ DEC 14, 2025 ------------------
  {
    id: 1,
    category: "next",
    teamA: { name: "AJVJ", logo: "/Images/teamlogo3.jpeg.jpg" },
    teamB: { name: "SK Salem", logo: "/Images/teamlogo9.jpeg.jpg" },
    date: "Dec 14, 2025",
    time: "8:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 2,
    category: "next",
    teamA: { name: "AJVJ", logo: "/Images/teamlogo3.jpeg.jpg" },
    teamB: { name: "Queens", logo: "/Images/teamlogo8.jpeg.jpg" },
    date: "Dec 14, 2025",
    time: "11:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 3,
    category: "next",
    teamA: { name: "Queens", logo: "/Images/teamlogo8.jpeg.jpg" },
    teamB: { name: "SK Salem", logo: "/Images/teamlogo9.jpeg.jpg" },
    date: "Dec 14, 2025",
    time: "2:00 PM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },

  // ------------------ DEC 15, 2025 ------------------
  {
    id: 4,
    category: "next",
    teamA: { name: "Signature", logo: "/Images/teamlogo5.jpeg.jpg" },
    teamB: { name: "Kairaa", logo: "/Images/teamlogo1.jpeg.jpg" },
    date: "Dec 15, 2025",
    time: "8:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 5,
    category: "next",
    teamA: { name: "Signature", logo: "/Images/teamlogo5.jpeg.jpg" },
    teamB: { name: "Believe", logo: "/Images/teamlogo7.jpeg.jpg" },
    date: "Dec 15, 2025",
    time: "11:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 6,
    category: "next",
    teamA: { name: "Kairaa", logo: "/Images/teamlogo1.jpeg.jpg" },
    teamB: { name: "Believe", logo: "/Images/teamlogo7.jpeg.jpg" },
    date: "Dec 15, 2025",
    time: "2:00 PM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },

  // ------------------ DEC 16, 2025 ------------------
  {
    id: 7,
    category: "next",
    teamA: { name: "Risor", logo: "/Images/teamlogo1.jpeg.jpg" },
    teamB: { name: "SK SRMC", logo: "/Images/teamlogo1.jpeg.jpg" },
    date: "Dec 16, 2025",
    time: "8:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 8,
    category: "next",
    teamA: { name: "SK SRMC", logo: "/Images/teamlogo1.jpeg.jpg" },
    teamB: { name: "Fearless", logo: "/Images/teamlogo2.jpeg.jpg" },
    date: "Dec 16, 2025",
    time: "11:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 9,
    category: "next",
    teamA: { name: "Fearless", logo: "/Images/teamlogo2.jpeg.jpg" },
    teamB: { name: "Risor", logo: "/Images/teamlogo1.jpeg.jpg" },
    date: "Dec 16, 2025",
    time: "2:00 PM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },

  // ------------------ DEC 17, 2025 ------------------
  {
    id: 10,
    category: "next",
    teamA: { name: "Uttarakhand", logo: "/Images/teamlogo1.jpeg.jpg" },
    teamB: { name: "Guru Nanak", logo: "/Images/teamlogo4.jpeg.jpg" },
    date: "Dec 17, 2025",
    time: "8:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 11,
    category: "next",
    teamA: { name: "Guru Nanak", logo: "/Images/teamlogo4.jpeg.jpg" },
    teamB: { name: "SK Drome", logo: "/Images/teamlogo9.jpeg.jpg" },
    date: "Dec 17, 2025",
    time: "11:00 AM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  },
  {
    id: 12,
    category: "next",
    teamA: { name: "SK Drome", logo: "/Images/teamlogo5.jpeg.jpg" },
    teamB: { name: "Uttarakhand", logo: "/Images/teamlogo4.jpeg.jpg" },
    date: "Dec 17, 2025",
    time: "2:00 PM",
    venue: "10 K.T.S. Garden Tiruchirappalli"
  }
];
const CricketHomePage = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [index, setIndex] = useState(0);

  // Auto Slide
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % textSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const [slideIndex, setSlideIndex] = useState(0);

  const totalSlides = matchFixtures.length;

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex(prev => (prev + 1) % totalSlides);
    }, 6000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const next = () => setSlideIndex((slideIndex + 1) % totalSlides);
  const prev = () => setSlideIndex((slideIndex - 1 + totalSlides) % totalSlides);

  const match = matchFixtures[slideIndex];
  const groupedMatches = {
    previous: matchFixtures.filter(m => m.category === "previous"),
    current: matchFixtures.filter(m => m.category === "current"),
    next: matchFixtures.filter(m => m.category === "next")
  };

  return (
    <div className="Section1">
      <section className="cricket-section1">

        <div className="heroOverlay6">
          <div className="heroContent5">
            <p className="heroSub">CRICKET ● WOMEN’S T-20 ● NATIONAL LEVEL</p>
            <h1 className="heroTitle">ATPL Women’s T-20 Championship</h1>
            <p className="heroDesc">
              Where Passion Meets Power. Where Talent Becomes Legend.
            </p>
          </div>


          <div className="slide-wrapper31">

            <button className="arrow-btn31 prev31" onClick={prev}>←</button>

            <div className="match-box31">
              <h2 className="category-title31">
                <span className="title-decor31">
                  {match.category === "previous"
                    ? "Previous Match"
                    : match.category === "current"
                      ? "Current Match"
                      : "Upcoming Match"}
                </span>
              </h2>
              <div className="team-row31">
                <div className="team31">
                  <img src={match.teamA.logo} alt="" className="team-img31" />
                  <p className="team-name31">{match.teamA.name}</p>
                </div>

                <span className="vs31">VS</span>

                <div className="team31">
                  <img src={match.teamB.logo} alt="" className="team-img31" />
                  <p className="team-name31">{match.teamB.name}</p>
                </div>
              </div>

              <div className="details31">
                <p><FaCalendarAlt /> {match.date} • {match.time}</p>
                <p>{match.venue}</p>
              </div>

            </div>

            <button className="arrow-btn31 next31" onClick={next}>→</button>
          </div>

          <div className="textSlider998">

            {/* <button className="arrow998" onClick={prev}>←</button> */}

            <div key={index} className="slideBox998">
              <div className="slideTrack998">
                <h3 className="slideTitle998">{textSlides[index].title} — </h3>
                <ul className="slidePoints998">
                  {textSlides[index].points.map((point, i) => (
                    <li key={i}>{point} • </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* <button className="arrow998" onClick={next}>→</button> */}
          </div>
          <button
            className="inspiration-btnEG"
            onClick={() => {
              navigate("/Dec2025_Womens_T20-register");
              window.scrollTo(0, 0);
            }}
          >
            <span>Register now</span>
          </button>
        </div>

      </section>


      <section className="cricket-players-section">
        <PlayersSection />
      </section>
      <div className="fixtures-wrap">

        {/* GROUPS */}
        <motion.h2 initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          FIXTURES
        </motion.h2>

        <div className="group-grid">
          {Object.entries(groups).map(([group, teams], i) => (
            <motion.div
              key={group}
              className="group-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.15 }}
            >
              <h3>{group}</h3>
              <ul>
                {teams.map((team) => (
                  <li key={team}>{team}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* SCHEDULE */}
        <motion.h2
          className="schedule-title"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
        >
          ATPL Women’s T-20 MATCH SCHEDULE
        </motion.h2>

        <div className="schedule-table">
         <div className="schedule-header">
  <span className="head-date">Date</span>
  <span className="head-time">8 AM</span>
  <span className="head-time">11 AM</span>
  <span className="head-time">2 PM</span>
</div>


          {schedule.map((row, i) => (
            <motion.div
              className="schedule-row"
              key={i}
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.08 }}
            >
              <span className="date-pill">{row.date}</span>
             <span className="match-text">
  {row.t1?.split(" vs ").map((text, index) =>
    index === 0 ? (
      <strong key={index}>{text}</strong>
    ) : (
      <React.Fragment key={index}>
        <span className="vs-text"> vs </span>
        <strong>{text}</strong>
      </React.Fragment>
    )
  )}
</span>

<span className="match-text">
  {row.t2?.includes("vs") ? (
    row.t2.split(" vs ").map((text, index) =>
      index === 0 ? (
        <strong key={index}>{text}</strong>
      ) : (
        <React.Fragment key={index}>
          <span className="vs-text"> vs </span>
          <strong>{text}</strong>
        </React.Fragment>
      )
    )
  ) : (
    row.t2
  )}
</span>

<span className="match-text">
  {row.t3?.includes("vs") ? (
    row.t3.split(" vs ").map((text, index) =>
      index === 0 ? (
        <strong key={index}>{text}</strong>
      ) : (
        <React.Fragment key={index}>
          <span className="vs-text"> vs </span>
          <strong>{text}</strong>
        </React.Fragment>
      )
    )
  ) : (
    row.t3
  )}
</span>

            </motion.div>
          ))}
        </div>

      </div>
      <section className="forthcoming59-section">
        <ForthcomingEvents />
      </section>
      <section className="offerings59-section">
        <OurOfferings />
      </section>
      <section className="cricket-gallery-section">
        <CricketGallery />
      </section>
      <section className="team-section59Players">
        <img
          src="/Images/ballimg1.png"
          alt="Team Banner"
          className="team-top-image59Players"
        />
        <p className="team-subtitle59Players">younger generation meets </p>
        <p className="team-title59Players">Our Inspiring players</p>
        <div className="team-container59Players">
          {teamMembers.map((player, index) => (
            <div
              key={index}
              className={`team-card59Players ${hoveredIndex !== null && hoveredIndex !== index
                ? "fade59Players"
                : ""
                }`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="social-icons59Players">
                <a href="#"><FaFacebookF /></a>
                <a href="#"><FaLinkedinIn /></a>
                <a href="#"><FaTwitter /></a>
                <a href="#"><FaYoutube /></a>
              </div>
              <div className="team-img59Players">
                <img src={player.img} alt={player.name} />
              </div>
              <button className="team-btn59Players">
                <span className="player-name59Players">{player.name}</span>
                <span className="player-role59Players">{player.role}</span>
              </button>
            </div>
          ))}
        </div>
        <div className="view-all59Players">
          <button onClick={() => window.location.href = "/cricket-homepage"}>View All</button>
        </div>
      </section>
    </div>
  );
};

export default CricketHomePage;
